import { STANDARD_QUERY_CACHE_CONFIG } from "@lending/lib/queryConfig";
import { useApi } from "../../lib/api";

function useGetDisclosuresQuery(productUuid?: string) {
  const $api = useApi();
  const query = $api.useQuery(
    "get",
    "/v2/lending/disclosures",
    { params: { query: { product_uuid: productUuid } } },
    // Without a product UUID the endpoint returns only FI-wide disclosures, so
    // wait for it rather than risk omitting product-specific ones.
    { ...STANDARD_QUERY_CACHE_CONFIG, enabled: Boolean(productUuid) }
  );

  return {
    disclosures: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
  };
}

export { useGetDisclosuresQuery };
